/** @format */

import React, { useEffect, useRef, useState } from 'react';
import { Avatar } from './avatar';
import styles from './globalHeader.module.scss';

import { useTranslation } from 'react-i18next';
import LanguageSelectorModal from '../LanguageSelectorModal';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'src/store';
import { updateUserProfilePicture } from 'src/slices/users';
import { HELP_DASHBOARD_ID } from 'src/constants';

export const UserInfo = props => {
  const { isMobile, data, logout } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { userProfile } = useSelector(state => state.users);
  const [lanugageSelectorToggle, setLanguageSelectorToggle] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!userProfile || !userProfile.picture) {
      dispatch(updateUserProfilePicture());
    }
    // eslint-disable-next-line
  }, []);

  // Đóng menu khi click ra ngoài
  useEffect(() => {
    if (!dropdownOpen) return;
    const handleClickOutside = e => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [dropdownOpen]);

  const closeAndNavigate = path => {
    setDropdownOpen(false);
    history.push(path);
  };

  const languageSelectorHandler = event => {
    event.preventDefault();
    setLanguageSelectorToggle(true);
    setDropdownOpen(false);
  };

  const user = data;

  return (
    <div className={`${styles.userInfo} ${isMobile ? styles.userInfoMobile : ''}`} ref={menuRef}>
      {!isMobile && (
        <div className={styles.userInfoDetail}>
          <p className={styles.userInfoDetail__name}>
            {user && user.firstName && `${user?.firstName} ${user?.lastName}`}
          </p>
        </div>
      )}
      <div className={styles.userInfoDropDownWrapper}>
        <button
          type="button"
          className={styles.userInfoDropDownButton}
          onClick={() => setDropdownOpen(!dropdownOpen)}
          aria-expanded={dropdownOpen}
          aria-haspopup="true"
        >
          <Avatar srcImg={userProfile?.picture || ''} name={`${user?.firstName} ${user?.lastName}`} />
        </button>
        {dropdownOpen && (
          <ul className={`${styles.userInfoDropDown} ${styles.userInfoDropDownMenu}`}>
            <li>
              <button
                type="button"
                className={styles.menuProfile}
                onClick={() => closeAndNavigate('/profile')}
              >
                {t('menu.profile')}
              </button>
            </li>
            <li>
              <button
                type="button"
                className={styles.menuHelp}
                onClick={() => closeAndNavigate(`/dashboard/${HELP_DASHBOARD_ID}`)}
              >
                {t('menu.help')}
              </button>
            </li>
            {isMobile && (
              <li>
                <button
                  type="button"
                  className={styles.menuLanguage}
                  onClick={languageSelectorHandler}
                >
                  {t('menu.language')}
                </button>
              </li>
            )}
            <li className={styles.menuDivider} role="separator" />
            <li>
              <button
                type="button"
                className={styles.menuLogout}
                onClick={e => {
                  e.preventDefault();
                  setDropdownOpen(false);
                  logout();
                }}
              >
                {t('menu.logout')}
              </button>
            </li>
          </ul>
        )}
      </div>
      <LanguageSelectorModal
        open={lanugageSelectorToggle}
        onClose={() => {
          setLanguageSelectorToggle(false);
        }}
        onLangChange={data => {
          props.onLangChange(data);
        }}
      />
    </div>
  );
};
